import '@splidejs/splide/css/core';
import Splide from '@splidejs/splide';

var initializeBlock = function( $block ) {

  if(!!$block[0]){
    $block = $block[0];
  }
  
  imageGrid = document.querySelector('.image-grid--slider');

  if( imageGrid ) {
    var splide = new Splide( '.image-grid--slider', {
      type: 'slide',
      perPage: 3,
      perMove: 1,
      gap: 20,
      snap: true,
      speed: 1000,
      arrows: true,
      arrowPath: 'M7.1149 13.2004C7.60305 13.6762 8.39451 13.6762 8.88266 13.2004L14.186 8.03079C14.3224 7.89782 14.4207 7.74176 14.4808 7.57552C14.6363 7.14673 14.538 6.65009 14.1862 6.30707L8.88285 1.13747C8.3947 0.661617 7.60324 0.661616 7.11508 1.13747C6.62693 1.61331 6.62693 2.38482 7.11508 2.86067L11.5347 7.16884L7.1149 11.4772C6.62674 11.953 6.62674 12.7245 7.1149 13.2004Z',
      pagination: false,
      wheel: false,
      breakpoints: {
        960: {
          perPage: 2,
        },
      }
    });
    splide.mount();
  }

}

// Initialize each block on page load (front end).
document.addEventListener( 'DOMContentLoaded', function() {
  var sliders = document.querySelectorAll('.image-grid--slider');
  Array.prototype.forEach.call(sliders, function(el, i){
    initializeBlock(el);
  });
});

// Initialize dynamic block preview (editor).
if( window.acf ) {
  window.acf.addAction( 'render_block_preview/type=image-grid', initializeBlock );
}